import { render, staticRenderFns } from "./reset.component.vue?vue&type=template&id=6667ac26&scoped=true"
import script from "./reset.component.vue?vue&type=script&lang=js"
export * from "./reset.component.vue?vue&type=script&lang=js"
import style0 from "./reset.component.vue?vue&type=style&index=0&id=6667ac26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6667ac26",
  null
  
)

export default component.exports